import { AbgSxProps } from '@abg/typings';

export const VideoPlayerPlayButtonStyle: AbgSxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  '&:hover': {
    cursor: 'pointer',
  },
  zIndex: 1,
};

export const VideoPlayerStyle: AbgSxProps = {
  backgroundColor: 'black',
  width: '100%',
  height: {
    xs: '536px',
    sm: '617px',
  },
  top: {
    sm: '50%',
  },
  bottom: {
    xs: '-40%',
    sm: '-18%',
  },
  border: 'none',
};
export const PlayButtontnStyle: AbgSxProps = {
  height: '55px',
  width: '55px',
};

export const ContainerStyle: AbgSxProps = {
  height: '100%',
};

export const VideoContainerStyle: AbgSxProps = {
  position: 'absolute',
  top: {
    sm: '50%',
  },
  bottom: {
    xs: '-40%',
    sm: '-18%',
  },
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 1167,
  backgroundColor: 'none',
  boxShadow: 'none',
  p: 2,
  outline: 'none',
  borderRadius: 2,
  padding: {
    xs: 0,
  },
};

export const CloseIconStyle: AbgSxProps = {
  position: 'absolute',
  top: {
    xs: '7px',
    sm: '3px',
  },
  right: {
    xs: '0px',
    sm: '0px',
  },
  zIndex: 1,
};
